import { generateTranslations } from '../i18n/translation';

const namespace = 'steder.ps';

const translations = generateTranslations(namespace, {
  avdeling: {
    nb: 'Avdeling',
    en: 'Place',
  },
  avtale: {
    nb: 'Avtale',
    en: 'Agreement',
  },
  status: {
    nb: 'Status',
    en: 'Status',
  },
  bestilling: {
    nb: 'Bestilling',
    en: 'Order',
  },
  kapasitet: {
    nb: 'Kapasitet',
    en: 'Capacity',
  },
  bekreftet: {
    nb: 'Bekreftet',
    en: 'Confirmed',
  },
  ubekreftet: {
    nb: 'Ubekreftet',
    en: 'Unconfirmed',
  },
  bekreftetUnder: {
    nb: 'Alle underliggende steder er bekreftet',
    en: 'All places below are confirmed',
  },
  ubekreftetUnder: {
    nb: 'Underliggende steder er ubekreftet',
    en: 'Places below are unconfirmed',
  },
  avtalefeil: {
    nb: 'Ugyldig avtale. Kontakt studiestedkoordinator.',
    en: 'Invalid agreement. Contact institution.',
  },
  studiestedKapasitet: {
    nb: 'Satt av studiested ({kapasitet})',
    en: 'From institution ({kapasitet})',
  },
  kapasitetconfirmTitle: {
    nb: 'Bekreft kapasitet for praksisaktiviteten',
    en: 'Confirm order',
  },
  kapasitetconfirmSubTitle: {
    nb: 'Aktivitetsperiode {fromDate} - {toDate}',
    en: 'Practice period {fromDate} - {toDate}',
  },
  kapasitetZeroConfirmContents: {
    nb: 'Du er i ferd med å melde inn 0 i kapasitet på minst én bestilling. Er du sikker på at du vil fortsette?',
    en: 'You are about to set a capacity of 0 on at least one order. Are you sure that you want to proceed?',
  },
  kapasitetBindendeConfirmContents1: {
    nb: 'Du er i ferd med å melde inn kapasiteten til ',
    en: 'You are about to respond with your capacity to ',
  },
  kapasitetBindendeConfirmContents2: {
    nb: 'Selv om uforutsette endringer kan forekomme, er det viktig at du forstår at innsendt kapasitet er bindende.',
    en: 'Although unforeseen changes may happen, it is important to realize that the capacity you respond with is binding.',
  },
  bekreftetconfirmTitle: {
    nb: 'Bekreft bestilling',
    en: 'Confirm order',
  },
  bekreftetconfirmContents: {
    nb: 'Du er i ferd med å endre ditt opprinnelige tilbud',
    en: 'You are about to change your original order',
  },
  lagre: {
    nb: 'Lagre',
    en: 'Save',
  },
  bekreft: {
    nb: 'Bekreft bestilling',
    en: 'Confirm order',
  },
  lagretMsg: {
    nb: 'Kapasitet lagret',
    en: 'Capacity saved',
  },
  showAvtale: {
    nb: 'Vis avtale',
    en: 'Show agreement',
  },
});

export default translations;
